/**
 * Shared look for the third-party sign-in buttons, built to Google's custom
 * "Sign in with Google" spec (light theme): white fill, 1px #747775 stroke,
 * #1F1F1F Google Sans Medium 14/20, 20px logo, 12px side padding, 10px gap.
 * Google also requires its button to be at least as prominent as other
 * providers, so Facebook and email use the same box (44px tall, matching the
 * Xero widget). https://developers.google.com/identity/branding-guidelines
 */
export const socialButtonClass =
  "h-11 w-full gap-2.5 rounded px-3 border-[#747775] bg-white font-['Google_Sans',Inter,sans-serif] text-sm font-medium leading-5 text-[#1F1F1F] hover:bg-[#F8F9FA]"

/** Provider logos render at 20px, unaltered (official assets only). */
export const socialLogoClass = 'size-5 shrink-0'
